function isString(value) {
  return typeof value === 'string' || value instanceof String;
}

export { isString as i };
//# sourceMappingURL=isString-c7dc7f9f-edb7f9ec.js.map
